const CrudStore      = require("stores/abstract/CrudStore");
const cookie         = require("services/cookie");
const router         = require("services/router");
const env            = require("services/env");
const Pusher         = require("pusher-js");
const _              = require("lodash");
const EchoConnection = require("services/echo/EchoConnection").default;

class Notifications extends CrudStore {

    constructor(resource, constraints = {}, autofetch = true) {

        super('notification', constraints, autofetch);

        const user_id = env.get('user.id');

        EchoConnection.private(`user.${user_id}`)
            .listen('.notifications.delivery', (resp) => {

                this.play();

                this.customAction('receive', resp.notification_id, {}, {}, false)
                    .then(() => {
                        this.fetch();
                    });
            });
    }

    play = _.debounce(() => {
        const snd  = new Audio(router.url('sounds/notification.wav'));
        let repeat = 1;

        snd.play();
        snd.onended = () => {
            if (repeat > 0) {
                snd.play();
                repeat--;
            }
        };
    }, 5000, {leading: true, trailing: false});

    get acknowledgedNotifications() {
        return this.collection.filter(notification => notification.is_acknowledged === true);
    }

    get unacknowledgedNotifications() {
        return this.collection.filter(notification => notification.is_acknowledged === false);
    }

}

module.exports = Notifications;
